/* eslint-disable */
import { useEffect, useState } from 'react';
import styles from './StoreTiming.module.scss';
import { Clock, X } from 'lucide-react';
import { DatePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { getClosingTime } from '@/Helpers';

function formatTimeForInput(time) {
	const [hour, minute] = time.split(':');
	const hh = hour.padStart(2, '0');
	const mm = minute.padStart(2, '0');
	return `${hh}:${mm}`;
}

const StoreTiming = (props) => {
	const { fields, isDisabled, updateTime } = props;

	useEffect(() => {
		if (!fields.duration && fields?.openingTime) {
			const defaultDuration = new Date(0, 0, 0, 0, 30, 0);
			updateTime('duration', defaultDuration);
		}
	}, [fields?.openingTime, fields?.duration, updateTime]);

	return (
		<div className={`${styles.root}`}>
			{/* opening time */}
			<div className='form-field row'>
				<label
					className='form-label'
					htmlFor='openingTime'
				>
					Opening Time
				</label>
				<input
					className='form-value'
					type='time'
					value={fields.openingTime ? formatTimeForInput(fields.openingTime) : ''}
					onChange={(e) => updateTime('openingTime', e.target.value)}
					onClick={(e) => e.target.showPicker()}
					disabled={isDisabled}
				/>
				{fields.openingTime && !isDisabled && (
					<X
						onClick={() => updateTime('openingTime', '')}
						className='text-gray-400 cursor-pointer relative right-[4rem] top-[.8rem]'
						size={20}
					/>
				)}
			</div>
			{/* duration */}
			<div className='form-field row'>
				<label
					className='form-label'
					htmlFor='duration'
				>
					Duration
				</label>
				<DatePicker
					className='form-value'
					format='HH:mm:ss'
					value={fields.duration}
					onChange={(value) => updateTime('duration', value)}
					disabled={isDisabled}
					renderToggle={(props, ref) => (
						<div
							{...props}
							ref={ref}
							className='rs-picker-toggle form-value'
							style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
						>
							<span style={{ color: time ? '#000' : '#aaa' }}>
								{time ? time.toLocaleTimeString('en-GB') : 'HH:mm:ss'}
							</span>
							<Clock size={18} />
						</div>
					)}
				/>
			</div>
			{/* closing time */}
			<div className='form-field row'>
				<label
					className='form-label'
					htmlFor='closingTime'
				>
					Closing Time
				</label>
				<p>{fields.closingTime ?? ' '} {getClosingTime(fields.openingTime, fields.duration)?.isNextDay ? ' (Next Day)' : ''}</p>
			</div>
			<div />
		</div>
	);
};
StoreTiming.defaultProps = {
	isDisabled: false,
	mandatoryFields: {},
	errors: {},
	handleInput: () => { },
	handleFileInput: () => { },
	generateRequiredProps: () => {
		return {};
	},
};
export default StoreTiming;
